import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { sizes } from 'src/styles/Media.styled';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { useSelector } from 'react-redux';
import { VISIBLE } from 'src/constants/appConstants';
import { useTranslation } from 'react-i18next';
import { FONT_FAMILY_DEMI, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX, TITLE_FONT_COLOR } from '../../../../../../styles/fonts/MCFontConstants';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
    },
    gridPaddingLeft: {
        paddingLeft: '9px',
    },
}));

const RowHeaderTemplateDesktop = ({
    gridData,
    headerCheckboxClickHandler,
    countryCode,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const {
        transferRecipientVisibility
    } = useSelector((state) => state.loginReducer);
    return (
        <Box
            className={classes.paper}
            my={1}
            bgcolor={'#ffffff'}
            boxShadow={2}
            borderRadius={6}
            style={{ height: '48px' }}
            borderBottom={0}
        >
            <Grid container spacing={3} alignItems={'flex-start'}>
                <Grid
                    item
                    md={transferRecipientVisibility == VISIBLE ? 3 : 5}
                    sm={transferRecipientVisibility == VISIBLE ? 3 : 5}
                    style={{ display: 'flex', paddingTop: '10px' }}
                >
                    <Checkbox
                        id="reportUsage-replenishmentRequest-headerCheckbox"
                        checked={
                            gridData?.filter(
                                (x) => !x.isExcludedItem && !x.accountOwned
                            )?.length > 0 &&
                            gridData
                                .filter(
                                    (x) => !x.isExcludedItem && !x.accountOwned
                                )
                                .every((y) => y.isSelected)
                        }
                        label={t('reportUsage.record.reportPaymentTable.selectAll')}
                        labelStyleObj={{
                            fontFamily: FONT_FAMILY_DEMI,
                            textAlign: 'left',
                            fontSize: SEMANTIC_TEXT_SMALL_PX,
                            letterSpacing: '-0.12px',
                            color: TITLE_FONT_COLOR,
                            opacity: 1,
                            paddingLeft: SMALL_TEXT_PX,
                        }}
                        onCheckboxSelectionChange={headerCheckboxClickHandler}
                    />
                    {/* <StyledTextDiv
                        style={{
                            padding: '0 0 0 14px',
                            maxWidth: '90%',
                        }}
                        color="#1010EB"
                    >
                        Select All
                    </StyledTextDiv> */}
                </Grid>
                <Grid item md={3} sm={3} style={{ padding: '10px 0 0 10px' }}>
                    <StyledTextDiv>{t('reportUsage.replen.replenListView.shippingAddress')}</StyledTextDiv>
                </Grid>
               {transferRecipientVisibility == VISIBLE && <Grid item md={3} sm={3} style={{ padding: '10px 0 0 10px' }}>
                    <StyledTextDiv>{t('reportUsage.replen.selectShipToAddress.transferRecipient')}</StyledTextDiv>
                </Grid>}
                <Grid item md={transferRecipientVisibility == VISIBLE ? 2 : 3} sm={transferRecipientVisibility == VISIBLE ? 2 : 3} style={{ padding: '10px 0 0 10px' }}>
                    <StyledTextDiv>{t('reportUsage.replen.replenListView.shippingMethod')}</StyledTextDiv>
                </Grid>
                <Grid
                    item
                    md={
                        window.innerWidth === sizes.ipadAir &&
                        countryCode === COUNTRY_CODE_JAPN
                            ? ''
                            : 1
                    }
                    sm={
                        window.innerWidth === sizes.ipadAir &&
                        countryCode === COUNTRY_CODE_JAPN
                            ? ''
                            : 1
                    }
                    style={{
                        padding: '10px 18px',
                        width: transferRecipientVisibility == VISIBLE &&
                             window.innerWidth === sizes.ipadAir ? '0px' :
                             window.innerWidth === sizes.ipadAir &&
                             countryCode === COUNTRY_CODE_JAPN
                                ? '11.66%'
                                : '',
                        marginLeft: transferRecipientVisibility == VISIBLE &&
                            window.innerWidth === sizes.ipadAir ? '0px' :
                            window.innerWidth === sizes.ipadAir &&
                            countryCode === COUNTRY_CODE_JAPN
                                ? '38px'
                                : null,
                    }}
                >
                    <StyledTextDiv>{t('reportUsage.replen.replenListView.qty')}</StyledTextDiv>
                </Grid>
            </Grid>
        </Box>
    );
};

export default RowHeaderTemplateDesktop;
